// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__8ZV9L","noHeader":"style_noHeader__TNutK"};